import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Category } from '../types';
import { AnchorageSyncRequest, IGetConnectionsResponse } from './api.interface';

export class ApiService {
  baseUrl: string;
  token: string;
  instance: AxiosInstance;

  constructor(token: string) {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
    this.token = token;
    this.instance = this.createInstance();
  }

  createInstance() {
    const instance: AxiosInstance = axios.create({
      baseURL: this.baseUrl,
    });

    instance.interceptors.request.use((config: AxiosRequestConfig) => {
      config.headers = {
        Authorization: `Basic ${this.token}`,
      };
      return config;
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => error
    );

    return instance;
  }

  async getCategories() {
    const response = await this.instance.get<{ data: Array<Category> }>(
      '/accounting-categories'
    );

    return response.data?.data;
  }

  async syncCategories() {
    const response = await this.instance.post<{ data: Array<Category> }>(
      '/accounting-categories'
    );

    return response.data?.data;
  }

  async getConnections() {
    const response = await this.instance.get<IGetConnectionsResponse>(
      '/accounting/connections'
    );

    return response.data?.data;
  }

  async createCompany(name: string) {
    const response = await this.instance.post('/accounting/company', { name });

    return response.data?.data;
  }

  async syncAnchorage(request: AnchorageSyncRequest) {
    const response = await this.instance.post('/anchorage/sync', request);
    return response.data?.data;
  }

}
